import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { SearchAnalyticsEvents } from './searchAnalytics.events'

class SearchAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.SEARCH)
  }

  public logTypeInSearchBar(searchInput: string): void {
    this.logEvent({
      event: SearchAnalyticsEvents.TYPES_IN_THE_SEARCHBAR,
      value: searchInput,
    })
  }

  public logSearchResultClick(index: number, searchResult: string, searchInput: string): void {
    this.logEvent({
      product: PortalProducts.NAVIGATION,
      event: SearchAnalyticsEvents.SEARCH_RESULT_CLICK,
      position: index + 1,
      title: searchResult,
      value: searchInput,
    })
  }

  public logSearchSend(searchInput: string): void {
    this.logEvent({
      event: SearchAnalyticsEvents.SEARCH,
      term: searchInput,
    })
  }

  public logSearchClick(): void {
    this.logEvent({
      event: SearchAnalyticsEvents.SEARCH_CLICK,
    })
  }
}

export default new SearchAnalytics()
